import { createReducer, on } from '@ngrx/store';
import { AircraftState, initialAircraftState } from './aircraft.state';
import { AIRCRAFT_ACTIONS } from '.';

export const aircraftReducer = createReducer(
  initialAircraftState,

  // Aircraft
  on(
    AIRCRAFT_ACTIONS.triggerAircrafts,
    (state): AircraftState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AIRCRAFT_ACTIONS.aircraftsSuccess,
    (state, { aircrafts }): AircraftState => ({ ...state, aircrafts, loading: false })
  ),
  on(
    AIRCRAFT_ACTIONS.aircraftsFailure,
    (state, { error }): AircraftState => ({ ...state, error, loading: false })
  ),

  // Aircraft Makes
  on(
    AIRCRAFT_ACTIONS.triggerAircraftMakes,
    (state): AircraftState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AIRCRAFT_ACTIONS.aircraftMakesSuccess,
    (state, { aircraftMakes }): AircraftState => ({ ...state, aircraftMakes, loading: false })
  ),
  on(
    AIRCRAFT_ACTIONS.aircraftMakesFailure,
    (state, { error }): AircraftState => ({ ...state, error, loading: false })
  ),

  // Aircraft Models
  on(
    AIRCRAFT_ACTIONS.triggerAircraftModels,
    (state): AircraftState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AIRCRAFT_ACTIONS.aircraftModelsSuccess,
    (state, { aircraftModels }): AircraftState => ({ ...state, aircraftModels, loading: false })
  ),
  on(
    AIRCRAFT_ACTIONS.aircraftModelsFailure,
    (state, { error }): AircraftState => ({ ...state, error, loading: false })
  ),

  // APU Models
  on(
    AIRCRAFT_ACTIONS.triggerApuModels,
    (state): AircraftState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AIRCRAFT_ACTIONS.apuModelsSuccess,
    (state, { apuModels }): AircraftState => ({ ...state, apuModels, loading: false })
  ),
  on(
    AIRCRAFT_ACTIONS.apuModelsFailure,
    (state, { error }): AircraftState => ({ ...state, error, loading: false })
  )
);
